import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TLocationManagementState } from './location-management.models';

export const getLocationManagementState = (state: TMachineMaintenanceState) => state.locationManagementInfo;

export const getLocationListInfo = createSelector(
  getLocationManagementState,
  (state: TLocationManagementState) => state.locationListingInfo,
);

export const getPagination = createSelector(
  getLocationManagementState,
  (state: TLocationManagementState) => state.locationListingPagination,
);

export const getAssignEmployeeDropdownInfo = createSelector(
  getLocationManagementState,
  (state: TLocationManagementState) => state.assignEmployeeDropdown?.minimalEmployeeDetailsList,
);

export const getFloatingAreaFloorsForLocationDeletion = createSelector(
  getLocationManagementState,
  (state: TLocationManagementState) => state.floatingAreaFloorsForLocationDeletion,
);

export const getLocalNeedleStores = createSelector(
  getLocationManagementState,
  (state: TLocationManagementState) => state.localNeedleStoresInfo,
);
